import { LiquidProduct } from '@/features/product/types'
import { getVariantFromOptions } from './getVariantFromOptions'

/**
 * Checks whether an option is in stock when selected with the other options
 * @param option The value of the option
 * @param optionIndex The index of the option
 * @param selectedOptions The currently selected options
 * @param variants The available variants for a product
 */
export const isOptionInStock = (
  option: string,
  optionIndex: number,
  selectedOptions: string[],
  variants: LiquidProduct['variants'],
): boolean => {
  const selectedOptionsWithNewOption = [
    ...selectedOptions.slice(0, optionIndex),
    option,
    ...selectedOptions.slice(optionIndex + 1),
  ]

  if (selectedOptions.length === 0)
    return variants
      .filter((variant) => variant.options[optionIndex] === option)
      .some(
        (variant) =>
          variant.in_stock || variant.inventory_policy === 'continue',
      )

  return variants.some(
    (variant) =>
      variant.options.every(
        (option, index) =>
          !selectedOptionsWithNewOption[index] ||
          option === selectedOptionsWithNewOption[index],
      ) &&
      (variant.in_stock || variant.inventory_policy === 'continue'),
  )
}
